<div class="new">
    <h2 *ngIf="new" class="bold-primary">{{ 'creditLetter.new.title' | translate }}</h2>
    <h2 *ngIf="!new" class="bold-primary" [ngClass]="creditLetter?.currentStatus == 'APPROVED' ? 'green' : creditLetter?.currentStatus == 'DENIED' ? 'red' : creditLetter?.currentStatus == 'STARTED' ? 'margin-bottom' : ''">
        {{ '#' + creditLetter?.id }} - {{ 'creditLetter.statusEnum.' + creditLetter?.currentStatus | translate }}
    </h2>

    <p class="status-description" *ngIf="creditLetter?.currentStatus == 'ANALYSING'">
        {{ 'creditLetter.new.analyzingText' | translate }}
        <span *ngIf="enableContactButton">
            <span class="status-description" >{{ 'creditLetter.new.contactPre' | translate }}</span>
            <span class="underline" (click)="openContactModal()">{{ ('creditLetter.new.contact' | translate) }}</span>.
        </span>
    </p>

    <p class="status-description" *ngIf="creditLetter?.currentStatus == 'RETURNED'">
        {{ 'creditLetter.new.approvedLn1' | translate }}
        <span *ngIf="newValueAnswered" class="bold">{{ 'creditLetter.new.approvedLn2' | translate }}</span>
        {{ 'creditLetter.new.approvedLn3' | translate }}
        {{ creditLetter?.valueOffered  | currency: ('tokenInformation.currency' | translate ) }}

    </p>

    <div class="inline-vertical-align input-convert-values">
        <div class="big-value-container">
            <label class="input-label">{{ 'creditLetter.new.valueInMoney' | translate }}</label>
            <input (keydown.ArrowDown)="blockNegativeNumber($event, $event.target.value)"
                [disabled]="disablingInput()" type="text" class="input big-value" [(ngModel)]="requestedValueNumber"
                (input)="convertTokens($event.target.value)" placeholder="0,00"
                (keypress)="onKeyPressEvent($event)" appMaskValue>
        </div>
        <mat-icon class="swap-icon" fontSet="material-icons-round">swap_horiz</mat-icon>
        <div class="big-value-container">
            <label class="input-label">{{ 'creditLetter.new.convertedValue' | translate }}</label>
            <input disabled type="text" class="input big-value" [(ngModel)]="tokensAmount">
        </div>
    </div>

    <div class="documents" *ngIf="mayEditByStatus() || new">
        <h2 class="bold-primary">{{ 'creditLetter.new.documents' | translate }}</h2>
        <div class="add-file">
            <label class="underline-button" for="file">{{ 'creditLetter.new.addFile' | translate }}</label>
            <input id="file" type="file" multiple accept="image/png, image/jpeg, .doc, .docx, .pdf" (change)="addNewFile($event.target.files)" />
            <p class="file-type">{{ 'creditLetter.new.fileType' | translate }}</p>
        </div>
    </div>

    <div class="table-container" *ngIf="dataSource?.data?.length > 0">
        <div class="scroll-table">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ 'creditLetter.new.file' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span>{{getNameFromURL(element?.url)}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>{{ 'creditLetter.new.date' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span>
                            {{ element?.providedAt | date: 'shortDate' }}
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon (click)="openBottomSheet(element?.id)">delete</mat-icon>
                    </td>
                </ng-container>

                <tr mat-row [ngClass]="(index%2==1)? 'odd': 'even'"
                    *matRowDef="let row; columns: displayedColumns; let index = index">
                </tr>
                <tr mat-header-row class="odd" *matHeaderRowDef="displayedColumns"></tr>
            </table>    
        </div>
    </div>

    <p  *ngIf="dataSource?.data?.length === 0 && new" class="table-info-hint">{{ 'creditLetter.new.shouldAdd' | translate }}</p>

    <div class="history-container" *ngIf="creditLetter?.currentStatus == 'RETURNED' || creditLetter?.currentStatus == 'APPROVED' ||creditLetter?.currentStatus == 'DENIED'">
        <h2 class="bold-primary">{{ 'creditLetter.new.history' | translate }}</h2>

        <div class="history-list even" *ngIf="creditLetter?.currentStatus == 'APPROVED' ||creditLetter?.currentStatus == 'DENIED'">
            <p class="label-bold" [ngClass]="creditLetter?.currentStatus == 'APPROVED' ? 'green' : 'red'">
                {{ 'creditLetter.history.' + (creditLetter?.currentStatus == 'APPROVED' ? 'approvedBy' : 'deniedBy') | translate }}
                {{ (creditLetter?.history[0].analist ? creditLetter?.history[0].analist : userName) | titlecase }}
                {{ 'creditLetter.history.at' | translate }}
                {{ creditLetter?.history[0].date | date: 'shortDate' }} - {{ creditLetter?.history[0].date | date: 'shortTime' }}
            </p>
            <p class="text-message">
                {{ 'creditLetter.history.' + (creditLetter?.currentStatus == 'APPROVED' ? 'approvedIn' : 'deniedIn') | translate }}
                {{ creditLetter?.valueRequested | currency: ('tokenInformation.currency' | translate ) }}
                ({{ tokensAmount }} {{ 'creditLetter.history.tokens' | translate }})
            </p>
        </div>

        <div class="history-list" *ngFor="let message of creditLetter?.history; index as i" [ngClass]="(i%2==0)? 'odd': 'even'">
            <p class="label-bold">
                {{ 'creditLetter.history.from' | translate }}
                <span style="text-transform: capitalize;">{{ message?.analist ? message.analist : userName }}</span>
                <span *ngIf="!message?.analist">{{ 'creditLetter.history.requester' | translate }}</span>
                {{ 'creditLetter.history.at' | translate }}
                {{ message.date | date: 'shortDate' }} - {{ message.date | date: 'shortTime' }}

            </p>
            <p class="text-message">{{ message.comment }}</p>
        </div>
    </div>

    <div *ngIf="new" class="modal-buttons">
        <button (click)="backToPanel()" mat-flat-button class="btn outlined">{{ 'button.cancel' | translate }}</button>
        <button [disabled]="loading || (requestedValueNumber <= 0) || filesUploadedTable.length === 0 || filesSizeError" mat-flat-button class="btn default" (click)="createNewRequest()">{{ 'creditLetter.new.createRequest' | translate }}</button>
    </div>

    <div *ngIf="creditLetter?.currentStatus === 'STARTED'" class="modal-buttons">
        <button (click)="backToPanel()" mat-flat-button class="btn outlined">{{ 'button.cancel' | translate }}</button>
        <button [disabled]="loading || (requestedValueNumber <= 0) || filesUploadedTable.length === 0 || filesSizeError" mat-flat-button class="btn default" (click)="!view ? updateRequest() : editLetter(this.creditLetter?.id)">{{ 'creditLetter.' + (!view ? 'new.saveButton' : 'view.edit') | translate }}</button>
    </div>

    <div *ngIf="creditLetter?.currentStatus === 'RETURNED'" class="modal-buttons">
        <button (click)="answer()" mat-flat-button class="btn outlined">{{ 'creditLetter.new.answer' | translate }}</button>
        <button (click)="deny()" mat-flat-button class="btn outlined">{{ 'creditLetter.new.deny' | translate }}</button>
        <button [disabled]="loading || filesSizeError" mat-flat-button class="btn default" (click)="approve()">{{ 'creditLetter.new.approveRequest' | translate }}</button>
    </div>

</div>
<mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
